import React from 'react';

const AvisoPrivacidad = () => {
  return (
    <div className="legal-container">
      <h1>Aviso de Privacidad</h1>
      <p className="update-date">Última actualización: 28 de mayo de 2025</p>

      <p>
        En cumplimiento con lo dispuesto por la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (LFPDPPP),
        Sana Servicios Dentales, con domicilio en Oriente 4 #315, entre Sur 7 y Sur 9, Orizaba, Veracruz, C.P. 94300,
        y correo electrónico sanaservidental@gmail.com, es responsable del tratamiento, uso y protección de los datos personales que nos proporcione.
      </p>

      <h2>1. Datos personales que se recaban</h2>
      <p>Los datos personales que recabamos de forma directa, electrónica o presencial incluyen:</p>
      <ul>
        <li>Nombre completo</li>
        <li>Edad y fecha de nacimiento</li>
        <li>Teléfono y correo electrónico</li>
        <li>Domicilio</li>
        <li>Información clínica y antecedentes médicos dentales</li>
        <li>Datos de facturación (RFC, razón social, domicilio fiscal)</li>
      </ul>
      <p>
        En caso necesario, también podremos recabar datos personales sensibles, especialmente aquellos relacionados con su estado de salud,
        con el único fin de brindarle una atención odontológica adecuada.
      </p>

      <h2>2. Finalidad del tratamiento de datos personales</h2>
      <p>Los datos personales serán utilizados para las siguientes finalidades primarias:</p>
      <ul>
        <li>Brindar atención odontológica profesional</li>
        <li>Agendar, confirmar y dar seguimiento a citas</li>
        <li>Elaborar y conservar su expediente clínico</li>
        <li>Emitir facturación y comprobantes fiscales</li>
        <li>Cumplir con obligaciones legales en materia de salud</li>
      </ul>
      <p>Finalidades secundarias (opcionales):</p>
      <ul>
        <li>Envío de promociones, recordatorios y material informativo</li>
        <li>Aplicación de encuestas de satisfacción</li>
        <li>Comunicación de servicios o campañas de salud dental</li>
      </ul>
      <p>
        Si usted no desea que sus datos sean tratados para finalidades secundarias, puede manifestarlo en cualquier momento enviando un correo a:
        <a href="mailto:sanaservidental@gmail.com"> sanaservidental@gmail.com</a>.
      </p>
    </div>
  );
};

export default AvisoPrivacidad;